import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';

const stats = [
  { value: '5,000+', label: 'Merchants Served' },
  { value: '19M+', label: 'Transactions Processed' },
  { value: '2', label: 'Core Markets' },
  { value: '9+', label: 'Years of Service' }
];

const solutions = [
  'Multi-Channel Processing',
  'Advanced Security',
  'Real-Time Reporting',
  'Fast Settlement',
  'Scalable Solutions',
  'Dedicated Support'
];

const MergedSection = () => {
  const { toast } = useToast();
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (submitting || !newsletterEmail) return;
    setSubmitting(true);
    try {
      const res = await fetch(`/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: newsletterEmail }),
      });
      if (!res.ok) throw new Error('Failed');
      toast({
        title: 'Subscribed!',
        description: "You've been added to our newsletter.",
      });
      setNewsletterEmail('');
    } catch (err) {
      toast({
        title: 'Could not subscribe',
        description: 'Please check your email and try again.',
        variant: 'destructive',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="solutions" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-gray-900 via-[#1F4E79] to-gray-900">
      <div className="max-w-7xl mx-auto">
        
        {/* Stats Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-16 items-center mb-8">
          {/* Heading - Left */}
          <div>
            <h2 className="text-[2.75rem] sm:text-6xl lg:text-[4rem] font-bold text-white">
              Trusted by businesses across UK & Ireland
            </h2>

            {/* EPOS Image - Below Trusted heading (can be reverted) */}
            <div className="mt-8 lg:mt-4">
              <img
                src="https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/s1vmj9u4_SMALL%20DEVICE%20TYPE%201.png"
                alt="eCOMM Small Payment Device"
                className="max-w-md w-full h-auto"
              />
            </div>
          </div>

          {/* Stats List - Right */}
          <div className="space-y-0">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="py-8 border-b border-white/20 last:border-b-0"
              >
                <div className="text-5xl sm:text-6xl font-bold text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-xl text-white/80">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Solutions Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-32">
          {/* Heading and Solutions - Left */}
          <div>
            <h2 className="text-[2.75rem] sm:text-6xl lg:text-[4rem] font-bold text-white mb-12">
              A smarter way to run your business
            </h2>
            
            <div className="space-y-0">
              {solutions.map((solution, index) => (
                <div
                  key={index}
                  className="py-6 border-b border-white/20 last:border-b-0"
                >
                  <h3 className="text-2xl font-bold text-white">
                    {solution}
                  </h3>
                </div>
              ))}
            </div>
          </div>

          {/* Image - Right */}
          <div className="flex items-center justify-center py-24 lg:py-28">
            <img
              src="https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/dkdwhenq_HOMEPAGE.png"
              alt="Payment Solutions"
              className="w-full h-auto scale-[1.8] mt-40"
            />
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center pt-32">
          {/* Heading - Left */}
          <div>
            <h2 className="text-[2.75rem] sm:text-6xl lg:text-[4rem] font-bold text-white leading-tight">
              Stay connected<br />with eCOMM
            </h2>
          </div>

          {/* Form - Right */}
          <div>
            <p className="text-lg text-white/90 mb-6">
              Subscribe to our newsletter for the latest updates on payment solutions and industry insights.
            </p>
            <form
              onSubmit={handleNewsletterSubmit}
              className="flex flex-col sm:flex-row gap-4"
            >
              <Input
                type="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                required
                className="flex-1 h-12 px-4 bg-white/10 border-white/30 text-white placeholder:text-white/60 focus:border-white focus:ring-white"
                placeholder="Enter your email"
                data-testid="newsletter-email-input"
              />
              <Button
                type="submit"
                size="lg"
                disabled={submitting}
                className="bg-white text-[#1F4E79] hover:bg-white/90 px-8 h-12 font-bold"
                data-testid="newsletter-subscribe-btn"
              >
                {submitting ? 'Subscribing…' : 'Subscribe'}
              </Button>
            </form>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MergedSection;
